import axios from "axios";
import { toast } from "react-toastify";

export const fetchAllCountries = () =>
  axios
    .get(`${process.env.REACT_APP_BASE_URL}/country`)
    .then((res) => res.data.data)
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
